import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export async function sendDraft(groupId: string, draft: ChatMessage): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  await Tasks.messaging.createNewMessages(groupId, [
    {
      ...draft.toJSON(),
      repliedMessage: draft.repliedMessage,
      quote: draft.quote || undefined,
    },
  ]);

  group.draftsStore.removeDraftById(draft.id);
}
